/**
 * Label for an operation status on the list/card.
 * TCO-OPS01-071 / XT-417: never invent the orphan string "Unknown" when the
 * catalog join is missing — return empty so the UI can omit the badge.
 */
export const displayOperationStatusTitle = (
  title: string | null | undefined
): string => {
  if (title == null) return '';
  const trimmed = title.trim();
  if (!trimmed) return '';
  // Guard against legacy bad data that already stored the literal.
  if (/^(unknown|uknown)$/i.test(trimmed)) return '';
  return trimmed;
};
